module.exports = __webpack_public_path__ + "img/setting_information.4e8dcb52.svg";